module.exports = __webpack_public_path__ + "static/media/loho.6ce9074d.png";